// 被保人组件Minxins
import commonOptions from '../common/options.js';
import moment from 'moment';
export const insuredMixins = {
  data() {
    return {
      type: 0, // 操作类型（1：新增；2：修改）
      hasAdd: false // 是否需要新增被保人功能
    };
  },
  created() {
    // 解构url参数
    const { p } = this.$route.query;
    this.hasAdd = commonOptions.productCodeList.indexOf(p) > -1;
  },
	methods: {
    // 批单生效日选择限制
    batchDateDisDate(current) {
      return current && current < moment(this.effectiveDate);
    },
    // 出生日期选择限制
    birthdateDisDate(current) {
      return current && current > moment();
    },
	}
};
